/**
 * Where a long identifier-like string may wrap. A title such as
 * `Marinus_Trustees_Outsourcing_Policy_Guernsey_1_July_2026` has no spaces,
 * so a browser either overflows it or, with `overflow-wrap: anywhere`, cuts
 * it mid-word; splitting after underscores and slashes lets it wrap between
 * its words instead. The caller renders a `<wbr>` between the segments, so
 * copying the text copies exactly the original.
 *
 * @module lib/softBreaks
 */

/** The text split after each run of `_` or `/`; joined, it is the input. */
export function softBreakSegments(text: string): ReadonlyArray<string> {
  return text.match(/[^_/]*[_/]+|[^_/]+$/g) ?? [text];
}
